import React from 'react'

export default function KioskSvg(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 1.6C2 0.82 2.5385 0 3.40625 0H12.5938C13.4615 0 14 0.82 14 1.6V14.4C14 15.18 13.4615 16 12.5938 16H3.40625C2.5385 16 2 15.18 2 14.4V1.6ZM7.25 12C7.05109 12 6.86032 12.0843 6.71967 12.2343C6.57902 12.3843 6.5 12.5878 6.5 12.8C6.5 13.0122 6.57902 13.2157 6.71967 13.3657C6.86032 13.5157 7.05109 13.6 7.25 13.6H8.75C8.94891 13.6 9.13968 13.5157 9.28033 13.3657C9.42098 13.2157 9.5 13.0122 9.5 12.8C9.5 12.5878 9.42098 12.3843 9.28033 12.2343C9.13968 12.0843 8.94891 12 8.75 12H7.25Z"
        fill="currentColor"
      />
    </svg>
  )
}
